import { Component, EventEmitter, OnInit, Output,Input } from '@angular/core';
import { SendMessageModel, NotificationContentType } from "../../../models/inModels/MessageModel";
import { Message,SelectItem } from 'primeng/api';
import { UserService } from "../../../services/user/user.service";
import { BusinessService } from "../../../services/business/business-category.service";
import { AppComponent } from "../../../app.component";

@Component({
	selector: 'app-send-dialog',
	inputs:['contentId','contentType'],
	templateUrl: './send-dialog.component.html',
	styleUrls: ['./send-dialog.component.css']
})
export class SendDialogComponent implements OnInit {
	@Input() open: boolean;
	@Output() openChange: EventEmitter<boolean> = new EventEmitter<boolean>();
	
	toggleDialog(open: boolean) {
		if (this.open === open) {
			return;
		}

		this.open = open;
		console.log("Send All Dialog TOGGLE:",this.open);
		this.openChange.emit(this.open);
	}

	contentId;
	contentType: NotificationContentType;
	sendAllModel: SendMessageModel;
	groups: SelectItem[];
	businessCategories: SelectItem[];
	clients: SelectItem[];
	sending = false;
	showCalendar = false;
	constructor(
		public app: AppComponent,
		public userService: UserService,
		public businessService: BusinessService) {
		this.sendAllModel = new SendMessageModel();
		this.sendAllModel.Clients = [];
		this.sendAllModel.BusinessCategories = [];
		this.sendAllModel.Groups = [];
	}

	ngOnInit() {
		this.getGroups();
		this.getClients();
		this.getBusinessCategories();
	}

	getGroups() {
		this.userService.getGroupsList().then(
			x => {
				this.groups = x;
			},
			error => {
				this.app.msgs = [];
				this.app.msgs.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	getBusinessCategories() {
		this.businessService.getDropdownList().then(
			x => {
				this.businessCategories = x;
			},
			error => {
				this.app.msgs = [];
				this.app.msgs.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	getClients() {
		this.businessService.getDropdownClientsList().then(
			x => {
				this.clients = x;
			},
			error => {
				this.app.msgs = [];
				this.app.msgs.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	sendAll() {
		this.sending = true;
		
		if (this.contentId) {
			this.sendAllModel.ContentId = this.contentId;
		}

		if (this.contentType) {
			this.sendAllModel.ContentType = this.contentType;
		}
		
		this.userService.sendMessage(this.sendAllModel).then(
			result => {
				this.app.msgs = [];
				this.app.msgs.push({ severity: 'success', summary: 'Success', detail: "Message Sent." });
				
				this.toggleDialog(false);
				this.sendAllModel = new SendMessageModel();
				this.sendAllModel.Clients = [];
				this.sendAllModel.BusinessCategories = [];
				this.sendAllModel.Groups = [];
				this.showCalendar = false;
				this.sending = false;
			},
			error => {
				this.sending = false;
				this.app.msgs = [];
				this.app.msgs.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}


	onHide(event) {
		this.toggleDialog(false);
	}

	toggleCalendar() {
		this.sendAllModel.DateToSendUtc = null;
		this.showCalendar = !this.showCalendar;
	}
}



// WEBPACK FOOTER //
// ./src/app/components/notification/send-dialog/send-dialog.component.ts